/* import __COLOCATED_TEMPLATE__ from './transfer-flow.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action, set } from '@ember/object';
import { inject as service } from '@ember/service';
import { MONEY_INPUT_ID } from '@banking/ui/utils/constants';
import { Account } from '@square/dashboard-protos/models/squareup/banking/account_model';
import { updateQueryAction } from '@banking/ui/workflows/unified-activity/unified-activity';
let TransferFlow = (_class = class TransferFlow extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "currentTransfer", _descriptor, this);
    _initializerDefineProperty(this, "bankingAccountApi", _descriptor2, this);
    _initializerDefineProperty(this, "sentry", _descriptor3, this);
    _initializerDefineProperty(this, "savingsReporter", _descriptor4, this);
    _initializerDefineProperty(this, "plaidState", _descriptor5, this);
    _initializerDefineProperty(this, "applicationRouter", _descriptor6, this);
    _initializerDefineProperty(this, "isLoading", _descriptor7, this);
    _initializerDefineProperty(this, "page", _descriptor8, this);
    _initializerDefineProperty(this, "currentTransferEvents", _descriptor9, this);
  }
  goToBankLink(evt) {
    evt.preventDefault();
    if (this.args.showPlaidLink) {
      this.page = 'link-bank-info';
    } else {
      this.page = 'import-linked-bank';
    }
  }
  setPage(newPage) {
    this.page = newPage;
  }
  async goToConfirm() {
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    try {
      const transferEvents = await this.currentTransfer.estimateTransferEvents();
      this.currentTransferEvents = transferEvents;
    } catch (error) {
      // Ignore error attempting to estimate transfer events, confirm screen will
      // show a single estimated time
      this.sentry.captureException(error);
    } finally {
      this.isLoading = false;
      this.page = 'confirm';
    }
  }
  async completeTransfer() {
    if (this.isLoading) {
      return;
    }
    set(this, 'isLoading', true);
    try {
      await this.currentTransfer.createTransfer();
    } catch (error) {
      // TODO (SFSP-587) handle 401/403 and other expected errors
      this.sentry.captureException(error);
      this.page = 'error';
      this.isLoading = false;
      return;
    }
    try {
      await Promise.all([this.reloadAccounts(), this.reloadRecentActivity()]);
    } catch {
      // We throw away any errors encountered attempting to reload the customer's
      // recent activity and balances. Potentially we could show some sort of
      // error in recent activity or complete screen but for now this is better
      // than an error causing the transfer to appear failed.
    } finally {
      this.page = 'complete';
      this.isLoading = false;
    }
  }
  focusInput() {
    document.getElementById(MONEY_INPUT_ID)?.focus();
  }
  async initialize() {
    await this.currentTransfer.ready();
    this.isLoading = false;
  }
  reloadAccounts() {
    const accounts = [];
    if (this.currentTransfer.primaryAccount instanceof Account) {
      accounts.push(this.currentTransfer.primaryAccount);
    }
    if (this.currentTransfer.secondaryAccount instanceof Account) {
      accounts.push(this.currentTransfer.secondaryAccount);
    }

    // TODO: Reload via a batch-by-id endpoint would be more effective.
    const owners = [];
    accounts.forEach(({
      owner
    }) => {
      if (owner) {
        owners.push(owner);
      }
    });
    return this.bankingAccountApi.listAccounts(owners, {
      reload: true
    });
  }
  reloadRecentActivity() {
    if (this.currentTransfer.primaryAccount instanceof Account) {
      const sfsAccountId = this.currentTransfer.primaryAccount.metadata?.savingsAccount?.sfsAccountId;
      if (sfsAccountId) {
        if (this.savingsReporter.state.query.activityOwners.length > 0) {
          // Update the workflow with the same query to trigger a reload of
          // transactions.
          this.savingsReporter.emit(updateQueryAction(this.savingsReporter.state.query));
        }
      }
    }
    return null;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "currentTransfer", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "bankingAccountApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "sentry", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "savingsReporter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "plaidState", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "applicationRouter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "isLoading", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "page", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'enter-amount';
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "currentTransferEvents", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "goToBankLink", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goToBankLink"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setPage", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setPage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goToConfirm", [action], Object.getOwnPropertyDescriptor(_class.prototype, "goToConfirm"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "completeTransfer", [action], Object.getOwnPropertyDescriptor(_class.prototype, "completeTransfer"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "focusInput", [action], Object.getOwnPropertyDescriptor(_class.prototype, "focusInput"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "initialize", [action], Object.getOwnPropertyDescriptor(_class.prototype, "initialize"), _class.prototype), _class);
export { TransferFlow as default };